const urlRegex =
  /^(https?:\/\/)?([a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+)([\/a-zA-Z0-9@:%._+~#=]*)?(\?[a-zA-Z0-9&=_-]*)?(#[a-zA-Z0-9!\/]*)?$/i;

export const validateSocialMediaForm = (data) => {
  const errors = {};
  if (!data.type?.trim()) {
    errors.type = "Social media type is required.";
  }
  if (!data.url?.trim()) {
    errors.url = "Social media url is required.";
  } else if (!urlRegex.test(data.url)) {
    errors.url = "Social media url in invalid.";
  }
  return errors;
};
